import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { styled } from '@mui/material/styles';
import { Avatar, Box, Typography } from '@mui/material';
import cssStyles from '../../../utils/cssStyles';
import { useAppSelector } from '../../../store';
import { getAssetURl } from '../../../utils/url';

const RootStyle = styled('div')(({ theme }: any) => ({
  '&:before': {
    ...cssStyles(theme).bgBlur({
      blur: 2,
      color: theme.palette.primary.darker,
    }),
    top: 0,
    zIndex: 9,
    content: "''",
    width: '100%',
    height: '100%',
    position: 'absolute',
  },
}));

const InfoStyle = styled('div')(({ theme }) => ({
  left: 0,
  right: 0,
  zIndex: 99,
  position: 'absolute',
  marginTop: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    right: 'auto',
    display: 'flex',
    alignItems: 'center',
    left: theme.spacing(3),
    bottom: theme.spacing(2),
  },
}));
const ProfileCover = ({ myProfile }: any) => {
  const { fullName, position } = myProfile;
  const loggedInUserInfo = useAppSelector((state) => state.auth.user);
  const [imageError, setImageError] = useState(false);

  // Reset image error when user profile image changes
  useEffect(() => {
    setImageError(false);
  }, [loggedInUserInfo?.userProfileImage?.key]);

  return (
    <RootStyle>
      <InfoStyle>
          <Avatar
          alt={loggedInUserInfo?.name || 'User'}
          src={loggedInUserInfo?.userProfileImage?.key && !imageError ? getAssetURl(
              loggedInUserInfo?.userProfileImage?.key
          ) : undefined}
            imgProps={{ crossOrigin: 'anonymous' }}
          onError={() => {
            // Set error state when image fails to load
            setImageError(true);
          }}
            sx={{
              objectFit: 'contain',
              '& img': { objectFit: 'contain' },
              ml: { xs: 3, sm: 3, md: 0 },
            }}
        >
          {(!loggedInUserInfo?.userProfileImage?.key || imageError) 
            ? loggedInUserInfo?.name?.charAt(0)?.toUpperCase() || 'U'
            : null
          }
        </Avatar>

        <Box
          sx={{
            ml: { md: 3 },
            mt: { xs: 1, md: 0 },
            color: 'common.white',
            textAlign: { xs: 'center', md: 'left' },
          }}
        >
          <Typography
            variant='h4'
            className='text-capital'
          >
            {fullName}
          </Typography>
          <Typography
            sx={{ opacity: 0.72 }}
            className='text-capital'
          >
            {position}
          </Typography>
        </Box>
      </InfoStyle>
    </RootStyle>
  );
};
ProfileCover.propTypes = {
  myProfile: PropTypes.object,
};
export default ProfileCover;
